/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { withCookies } from 'react-cookie';
import { actChangeLanguage } from 'actions/loginStateActions';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Menu, MenuItem, Link } from '@material-ui/core';
import T from 'i18n-react';
import { LOGIN_PATH } from 'shared/routes';
import icwLogo from 'assets/img/icw-logo.png';

const useStyles = makeStyles((theme) => ({
  aLink: {
    textDecoration: 'none',
    color: '#fff',
    '&:hover': {
      textDecoration: 'none',
      color: '#03a9f4',
      backgroundColor: 'transparent',
    },
  },
  menuBtn: {
    padding: '0 !important',
    textTransform: 'capitalize',
  },
}));

const Header = (props) => {
  const {
    match: {
      params: { locale = 'en' },
    },
    location: { pathname },
    cookies,
  } = props;
  const path = pathname.substring(pathname.indexOf('/iSource'), pathname.length);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setLanguage = (lang) => {
    const link = `http://${window.location.host}/${lang}${path}`;

    window.location.href = link;
  };

  useEffect(() => {
    actChangeLanguage(cookies, locale);

    // eslint-disable-next-line
  }, [locale]);

  return (
    <div className={classes.root}>
      <Box bgcolor='#000' display='flex' justifyContent='flex-end' p={2}>
        <Box fontSize='16px' fontWeight='400' color='#fff' mx={2}>
          <Link classes={{ root: classes.aLink }} href='https://qmas.icw.io/news/'>
            {T.translate('iSource.news')}
          </Link>
        </Box>
        <Box fontSize='16px' fontWeight='400' color='#fff' mx={2}>
          <Link classes={{ root: classes.aLink }} href='https://qmas.icw.io/about/'>
            {T.translate('iSource.aboutUs')}
          </Link>
        </Box>
        <Box fontSize='16px' fontWeight='400' color='#fff' mx={2}>
          <Link classes={{ root: classes.aLink }} href='https://qmas.icw.io/contact-us/'>
            {T.translate('iSource.contactUs')}
          </Link>
        </Box>
        <Box fontSize='16px' fontWeight='400' color='#fff' mx={2}>
          <Link
            classes={{ root: classes.aLink }}
            href={`https://qmas.icw.io/${locale}${LOGIN_PATH}`}>
            {T.translate('iSource.login')}
          </Link>
        </Box>
        <Button
          classes={{ root: classes.menuBtn }}
          aria-controls='simple-menu'
          aria-haspopup='true'
          onClick={handleClick}>
          <Box fontSize='16px' fontWeight='400' color='#fff' mx={2}>
            {T.translate('iSource.languages')}
          </Box>
        </Button>
        <Menu
          id='simple-menu'
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <MenuItem onClick={() => setLanguage('en')}>English</MenuItem>
          <MenuItem onClick={() => setLanguage('zh-cn')}>简体中文</MenuItem>
          <MenuItem onClick={() => setLanguage('zh-hk')}>繁體中文</MenuItem>
        </Menu>
      </Box>
      <Box
        bgcolor='#000D30'
        display='flex'
        p={2}
        alignContent='center'
        flexDirection='row'
        alignItems='center'>
        <Box mx={4}>
          <img src={icwLogo} alt='' height='60' width='100' />
        </Box>
        <Box mx={6}>
          <Box fontFamily='Montserrat' fontSize='20px' fontWeight='normal' color='#fff'>
            iSource
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default withCookies(Header);
